// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5359233f","749":"1854b5ea","903":"f41276bb","959":"8e67cefb"}[chunkId] + ".chunk.js";
};